// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__2d3hG","error":"InputSecondary_error__2fwC4","disabled":"InputSecondary_disabled___SVPK"};